var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"7def95cf556fb024913e3e96e036341105a43fdf"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["unite-uko-embedded@gailarde"]={id:"7def95cf556fb024913e3e96e036341105a43fdf"};
      